// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5f68727","732":"fda73a07","977":"5d1f8447"}[chunkId] + ".chunk.js";
};